const apiServer = (window._env_ && window._env_.API_SERVER) || process.env.API_SERVER // eslint-disable-line no-underscore-dangle
export const defaultEndPoint = `${apiServer}/page-api`
export const companyWebPage = `${apiServer}/webpage`
export const mckinseyWebPage = process.env.MCK_HOST
export const supportEmail = process.env.SUPPORT_EMAIL
export const errMessages = {
  loadContent: 'Unable to load content',
  postEmail: 'Unable to post email form',
}
export const formFreezeTime = 5000
export const scrollDuration = 500
export const mainTabTitle = (window._env_ && window._env_.TEAM_NAME_LONG) || process.env.TEAM_NAME_LONG || 'Benchfarm' // eslint-disable-line no-underscore-dangle
export const companyShortName =
  (window._env_ && window._env_.TEAM_NAME_SHORT) || process.env.TEAM_NAME_SHORT || 'Benchfarm' // eslint-disable-line no-underscore-dangle
